import PropTypes from 'prop-types';
import React from 'react';

const SmallBanner = ({
  image,
  backUp,
  backgroundImage,
  ctaButtonText,
  ctaButtonTextColor,
  ctaButtonBackgroundColor,
  ctaUrl,
  ctaTarget
}) => (
  <div
    style={{ backgroundImage: `url(${backgroundImage})` }}
    className="small-banner"
  >
    <a
      className="small-banner__link"
      href={ctaUrl}
      target={ctaTarget}
      rel="noopener noreferrer"
    >
      <img
        className="small-banner__logo"
        src={image}
        onError={(e) => { e.target.src = backUp; }}
      />
      <span
        className="small-banner__button"
        style={{
          color: ctaButtonTextColor,
          backgroundColor: ctaButtonBackgroundColor
        }}
      >
        {ctaButtonText}
      </span>
    </a>
  </div>
);

SmallBanner.propTypes = {
  image: PropTypes.string,
  backUp: PropTypes.string,
  backgroundImage: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaButtonTextColor: PropTypes.string,
  ctaButtonBackgroundColor: PropTypes.string,
  ctaUrl: PropTypes.string,
  ctaTarget: PropTypes.string
};

export default SmallBanner;
